import { UserRatingValue } from "../generated/generatedTypes";

/**
 * The Korean label for each rating value. Shared so the guest-facing rating form and
 * the admin views cannot drift apart.
 */
export const USER_RATING_LABELS: Record<UserRatingValue, string> = {
  [UserRatingValue.LIKED]: "좋았어요",
  [UserRatingValue.DISLIKED]: "아쉬웠어요",
  [UserRatingValue.NOT_SURE]: "못 만났어요",
};

export const USER_RATING_OPTIONS: { value: UserRatingValue; label: string }[] = [
  UserRatingValue.LIKED,
  UserRatingValue.DISLIKED,
  UserRatingValue.NOT_SURE,
].map((value) => ({ value, label: USER_RATING_LABELS[value] }));
